import React from "react";
import ServiceCtaButton from "./ServiceCtaButton";

const ServiceHero = ({
  title,
  introduction,
  supportingText,
  eyebrow,
  align = "center",
  highlights,
  image,
  cta,
  variant,
}) => {
  const resolvedVariant = variant || (image ? "image" : "plain");
  const isLeftAligned = align === "left";

  const content = (
    <div
      className={`relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24 ${
        isLeftAligned ? "justify-start" : "justify-center"
      }`}
    >
      <div
        className={`text-white w-full ${isLeftAligned ? "max-w-3xl text-left" : "text-center max-w-6xl mx-auto"}`}
      >
        {eyebrow && (
          <p
            className="text-xs sm:text-sm font-semibold uppercase tracking-widest mb-3"
            style={{ color: "#db0058" }}
          >
            {eyebrow}
          </p>
        )}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white break-words">
          {title}
        </h1>
        {introduction && (
          <p
            className={`text-lg sm:text-xl md:text-2xl text-gray-100 mb-4 ${isLeftAligned ? "" : "max-w-4xl mx-auto"}`}
          >
            {introduction}
          </p>
        )}
        {supportingText && (
          <p
            className={`text-sm sm:text-base text-gray-300 mb-6 ${isLeftAligned ? "" : "max-w-3xl mx-auto"}`}
          >
            {supportingText}
          </p>
        )}
        {Array.isArray(highlights) && highlights.length > 0 && (
          <div
            className={`flex flex-wrap gap-x-8 gap-y-4 mt-2 mb-2 ${isLeftAligned ? "" : "justify-center"}`}
          >
            {highlights.map((highlight, index) => (
              <div key={highlight.label || index}>
                <p
                  className="text-2xl sm:text-3xl font-bold leading-none break-words"
                  style={{ color: "#db0058" }}
                >
                  {highlight.value}
                </p>
                <p className="mt-1 text-xs sm:text-sm text-gray-300">
                  {highlight.label}
                </p>
              </div>
            ))}
          </div>
        )}
        {cta && (
          <div className="mt-6">
            <ServiceCtaButton cta={cta} variant="primary" size="medium" />
          </div>
        )}
      </div>
    </div>
  );

  if (resolvedVariant === "plain" || !image) {
    return (
      <section
        className="py-16 sm:py-20 md:py-24 relative"
        style={{ backgroundColor: "#232528" }}
      >
        {content}
      </section>
    );
  }

  return (
    <section
      className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: `url('${image}')` }}
    >
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
      />
      {content}
    </section>
  );
};

export default ServiceHero;
